package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.extensions.padZero
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

fun formatTime(millis: Long): String {
    val instant = Instant.fromEpochMilliseconds(millis)
    val localDateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    val hour = localDateTime.hour.padZero()
    val minute = localDateTime.minute.padZero()
    return "$hour:$minute"
}
